import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getRemovablePreferenceDefaults } from "../removablePreferenceForm";

const PROTOCOLS = [
  "Finition directe",
  "Cire puis finition",
  "Essayage puis finition",
  "Cire, essayage puis finition",
];
const CUSTOM_TRAY_WITH_WAX = ["Non", "Oui"];

export const ProtocolPreferences = withForm({
  defaultValues: getRemovablePreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "protocol",
      "customTrayWithWax",
    ]);

    return (
      <SaveableCard
        title="Protocole"
        description="Étapes demandées par défaut · chaque étape est facturée"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <>
            <Text variant="strong">Protocole</Text>
            <form.Field name="protocol">
              {field => (
                <Group>
                  {PROTOCOLS.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <>
            <Text variant="strong">
              Porte-empreinte individuel avec la cire
            </Text>
            <form.Field name="customTrayWithWax">
              {field => (
                <Group>
                  {CUSTOM_TRAY_WITH_WAX.map(option => (
                    <ButtonCheckbox
                      key={option}
                      id={option}
                      isActive={field.state.value === option}
                      onClick={() => field.handleChange(option)}
                    >
                      {option}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
